module.exports = "/_next/static/images/parallax-5-3702c4a0c9f9c0e470fd9b25dcca1392.jpg.webp";